export default __webpack_public_path__ + "static/media/tecmundo.36cd10b8.png";